<template>
  <div>
    <el-card class="mb-10">
      <el-row>
        <el-col :span="12">
          <div
            id="qc1AreaChartContainer"
            :style="'width:' + width || '100%'"
          ></div>
        </el-col>
        <el-col :span="12">
          <div
            id="qc1RetentionChartContainer"
            :style="'width:' + width || '100%'"
          ></div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import Highcharts from "@/config/highcharts";
window.qc1AreaChart = null;
window.qc1RetentionChart = null;
export default {
  props: ["qc1Data", "width"],
  data() {
    return {
      chartData: {
        chart: {
          zoomType: "x",
        },
        scrollbar: {
          enabled: true,
          height: 10,
          showFull: false,
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
          enabled: false,
        },
        title: {
          text: "Area: 6−MAM 1 −− 1",
        },

        decimals: true,
        credits: {
          enabled: false,
        },
        yAxis: [
          {
            title: {
              text: "Area Count",
            },
            allowDecimals: false,
            lineWidth: 2,
            gridLineWidth: 0,
            tickWidth: 2,

            showEmpty: true,

            tickInterval: 1000,
          },
        ],
        xAxis: {
          categories: [],
          tickWidth: 2,
          tickmarkPlacement: "on",
          labels: {
            rotation: 290,
          },
          events: {
            afterSetExtremes: () => {},
          },
        },
        series: [
          {
            name: "",
            data: [],
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "downloadPNG",
                "downloadPDF",

                "separator",
                "downloadCSV",
              ],
            },
          },
        },
      },
      chartData2: {
        chart: {
          zoomType: "x",
        },
        scrollbar: {
          enabled: true,
          height: 10,
          showFull: false,
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "top",
          enabled: false,
        },
        title: {
          text: "Retention: 6−MAM 1 −− 1",
        },

        decimals: true,
        credits: {
          enabled: false,
        },
        yAxis: [
          {
            title: {
              text: "Retention Time (minutes)",
            },
            allowDecimals: false,
            lineWidth: 2,
            gridLineWidth: 0,
            tickWidth: 2,

            showEmpty: true,

            tickInterval: 1,
          },
        ],
        xAxis: {
          categories: [],
          tickWidth: 2,
          tickmarkPlacement: "on",
          labels: {
            rotation: 290,
          },
          events: {
            afterSetExtremes: () => {},
          },
        },
        series: [
          {
            name: "",
            data: [],
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "downloadPNG",
                "downloadPDF",

                "separator",
                "downloadCSV",
              ],
            },
          },
        },
      },
    };
  },
  mounted() {
    this.prepareChartData();
  },
  methods: {
    prepareChartData() {
      if (this.qc1Data.area_data) {
        let categories1 = this.qc1Data.area_data.map((e) => e.name);
        let values1 = this.qc1Data.area_data.map((e) => e.value);
        this.chartData.xAxis.categories = categories1;
        this.chartData.series[0].data = values1;
        this.chartData.title.text = `Area: ${this.qc1Data.drug} −− QCL`;

        window.qc1AreaChart = Highcharts.chart(
          "qc1AreaChartContainer",
          this.chartData
        );
      }
      if (this.qc1Data.retention_data) {
        let categories2 = this.qc1Data.retention_data.map((e) => e.name);
        let values2 = this.qc1Data.retention_data.map((e) => e.value);
        this.chartData2.xAxis.categories = categories2;
        this.chartData2.series[0].data = values2;
        this.chartData2.title.text = `Retention: ${this.qc1Data.drug} −− QCL`;

        window.qc1RetentionChart = Highcharts.chart(
          "qc1RetentionChartContainer",
          this.chartData2
        );
      }
    },
  },
};
</script>

<style lang="scss"></style>
